const Workbench = () => import('../views/DashboardSchool/Index.vue')

import workbenchIcon from '@/assets/images/icon_menu_workbench@2x.png'
import workbenchIconActive from '@/assets/images/icon_menu_workbench_active@2x.png'

export default [
  {
    path: '/workbench',
    name: 'workbench',
    component: Workbench,
    meta: {
      title: '工作台',
      icon: workbenchIcon,
      iconActive: workbenchIconActive,
      showMenu: true,
    },
  },
]
